import { __rest } from '../node_modules/tslib/tslib.es6.js';
import React__default, { forwardRef } from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import { useThemeColor } from './useThemeColor.js';

const CheckCircleIcon = forwardRef((_a, ref) => {
    var { backgroundColor: propBackgroundColor = 'transparent' } = _a, props = __rest(_a, ["backgroundColor"]);
    const getColor = useThemeColor();
    const backgroundColor = getColor(propBackgroundColor);
    return (React__default.createElement(SvgIcon, Object.assign({}, props, { ref: ref }),
        React__default.createElement("svg", { "data-name": "Group 12488", xmlns: "http://www.w3.org/2000/svg", width: "14", height: "14", viewBox: "0 0 14 14" },
            React__default.createElement("g", { "data-name": "Group 12329" },
                React__default.createElement("path", { "data-name": "Path 18368", d: "M6.6 0A6.6 6.6 0 1 1 0 6.6 6.6 6.6 0 0 1 6.6 0z", fill: backgroundColor })),
            React__default.createElement("path", { "data-name": "check (1)", d: "M1.92 4.178a.269.269 0 0 1-.19-.079L.079 2.449a.269.269 0 1 1 .381-.381l1.46 1.46L5.03.418A.269.269 0 1 1 5.411.8L2.11 4.1a.269.269 0 0 1-.19.078zm0 0", transform: "translate(3.857 4.343)", fill: "currentColor", stroke: "currentColor", strokeWidth: ".25px" }))));
});

export { CheckCircleIcon };
//# sourceMappingURL=CheckCircleIcon.js.map
